<div class="flex flex-col w-full">
    <div class="bg-background w-full">
        <div class="container mx-auto text-center max-w-xl pt-6 pb-12 px-2">
            <app-explainer-text heading="Glossar" id="course-overview">
                <p>
                    Hier findest du häufig verwendete Begriffe.<br>
                    Du kannst sie durchsuchen, sortieren und filtern.
                </p>
            </app-explainer-text>
        </div>
    </div>

    <app-glossary-search (update)="query.set($event ?? undefined)"></app-glossary-search>

    <div class="flex flex-row justify-center">
        <app-glossary-language-switch (update)="primaryLanguage.set($event)"></app-glossary-language-switch>

        <app-glossary-sorting (update)="sortAscending.set($event)"></app-glossary-sorting>
    </div>

    <app-glossary-tag-filters class="px-4" [tags]="tags" (update)="tagFilters.set($event)"></app-glossary-tag-filters>

    @for(group of glossary(); track group.name) {
    <app-glossary-group [group]="group"></app-glossary-group>
    }

    <app-glossary-contributors></app-glossary-contributors>
</div>